import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminAddTruckCategoryComponent } from "../admin-add-truck-category/admin-add-truck-category.component";
import { AdminEditTruckCategoryComponent } from "../admin-edit-truck-category/admin-edit-truck-category.component";
import { AdminService } from "../admin.service";
import { CommonHelperComponent } from "src/app/common-helper/common-helper.component";

@Component({
  selector: "app-admin-truck-category",
  templateUrl: "./admin-truck-category.component.html",
  styleUrls: ["./admin-truck-category.component.css"],
})
export class AdminTruckCategoryComponent implements OnInit {
  tripType: any = "-1";
  matdialogref!: MatDialogRef<AdminAddTruckCategoryComponent>;
  matDialogref!: MatDialogRef<AdminEditTruckCategoryComponent>;
  checkBox: boolean = false;
  editTruck: boolean = true;
  cancelTruck: boolean = false;
  delete: boolean = false;
  token: any;
  truckCategory: any;
  trucCatgkDeleteId: any = [];
  SelectedItems: number = 0;
  DeleteAction: boolean = false;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  total_cat_count: any;
  startPage: any = 1;
  last_page: any = 1;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  truckCatgNumber: any = -1;
  loading: boolean = false;
  addBtn: boolean = true;
  perPage: any = 10;
  truckTypeNumber: any = -1;
  search_btn: boolean = false;
  clear_Btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  // @ViewChild("newItem") newItem: ElementRef;
  @ViewChild("newItem", { static: false }) newItem!: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.truckCategoryGet(this.tripType, this.truckCatgNumber);
    this.pagination(1);
    this.tripType = "truck-category";
    localStorage.setItem("tripType", this.tripType);
  }
  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    this.truckCategoryGet(selectedTripType, this.truckCatgNumber);
  }
  addTruckCategory() {
    this.matdialogref = this.matDialog.open(AdminAddTruckCategoryComponent, {
      width: "40vw",
      autoFocus: false,
    });
    this.matdialogref.afterClosed().subscribe((x) => {
      this.truckCategoryGet(this.tripType, this.truckCatgNumber);
    });
  }
  deleteTruck() {
    if (this.SelectedItems == 0) {
      this.trucCatgkDeleteId = [];
    }
    if (this.SelectedItems <= 0) {
      this.snackBar.open("Please select trucks category to delete", "Fail", {
        duration: 5000,
      });
      return;
    } else {
      const dialogRef = this.matDialog.open(CommonHelperComponent, {
        data: {
          message: 'Are you sure you want to delete this record?'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.services
            .DeleteTruckCateg({ ids: this.trucCatgkDeleteId }, this.token)
            .subscribe(
              (response: any) => {
                if (response.status === 200 || response.status === 201) {
                  this.cancel();
                  this.snackBar.open(
                    "Truck category deleted successfully",
                    "Success",
                    {
                      duration: 5000,
                    }
                  );
                  this.truckCategoryGet(this.tripType, this.truckCatgNumber);
                }
              },
              (error) => {
                if (error.error.message === "jwt malformed") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                if (error.error.message === "jwt expired") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                if (error.error.message === "invalid signature") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                this.snackBar.open(error.error.message, "Fail", {
                  duration: 5000,
                });
              }
            );
        }
      });
    }
  }
  truckCategoryGet(tripType: any, type: any) {
    this.truckCatgNumber = type;
    this.loading = true;
    this.services
      .GetCategory(
        this.token,
        this.truckTypeNumber,
        this.perPage,
        this.startPage,
        true
      )
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.truckCategory = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
        },
        (error) => {
          this.loading = false;
          this.truckCategory = [];
          if (error.status == 404) {
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  editTruckCatg(item: any) {
    this.matDialogref = this.matDialog.open(AdminEditTruckCategoryComponent, {
      width: "60vw",
      data: item,
      autoFocus: false,
    });
    this.matDialogref.afterClosed().subscribe((x) => {
      this.truckCategoryGet(this.tripType, this.truckCatgNumber);
    });
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.search_btn = true;
    this.clear_Btn = false;
    this.searchButton = true;
    this.truckCatgNumber = -1;
    this.truckTypeNumber = -1;
    this.truckCategoryGet(this.truckCatgNumber, this.truckTypeNumber);
    this.fetch_page = 0;
    this.pagination(1);
    this.searchButton = true;
    this.toggleSearch = false;
    this.addBtn = true;
    this.editTruck = true;
    this.cancelTruck = false;
    this.delete = false;
    this.checkBox = false;
    this.DeleteAction = false;
    this.isInputValid = false;
  }

  onInputChange(value: any) {
    const containsSpecialChars = /[^\w\d\s]/.test(value);
    if (containsSpecialChars) {
      value = value.replace(/[^\w\d\s]/g, "");
      this.snackBar.open(
        "Special characters are not allowed, except spaces",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const previousLength = this.previousValue.length;
    this.previousValue = capitalizedValue;

    if (
      capitalizedValue.length < previousLength ||
      (capitalizedValue.length > previousLength && this.clear_Btn)
    ) {
      this.truckTypeNumber = -1;
      this.truckCategoryGet(this.truckCatgNumber, this.truckTypeNumber);
      this.fetch_page = 0;
      this.pagination(1);
      this.search_btn = true;
      this.clear_Btn = false;
    }

    if (capitalizedValue.length >= 1) {
      this.isInputValid = true;
    } else {
      this.cancel();
    }
  }

  select() {
    this.delete = true;
    this.editTruck = false;
    this.cancelTruck = true;
    this.checkBox = true;
    this.addBtn = false;
    this.DeleteAction = true;
    this.toggleSearch = false;
    this.searchButton = false;
  }
  cancel() {
    // this.resetSearch();
    this.search_btn = true;
    this.clear_Btn = false;
    this.searchButton = true;
    this.truckCatgNumber = -1;
    this.truckTypeNumber = -1;
    this.truckCategoryGet(this.truckCatgNumber, this.truckTypeNumber);
    this.fetch_page = 0;
    this.pagination(1);
    this.searchButton = true;
    this.toggleSearch = false;
    this.addBtn = true;
    this.editTruck = true;
    this.cancelTruck = false;
    this.delete = false;
    this.checkBox = false;
    this.DeleteAction = false;
    this.isInputValid = false;
  }
  public matItem(event: any, item: any, index: number) {
    if (event.checked) {
      this.trucCatgkDeleteId.push(item);
      this.SelectedItems += 1;
    } else {
      this.trucCatgkDeleteId.splice(index, 1);
      this.SelectedItems -= 1;
    }
  }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.truckCategoryGet(this.tripType, this.truckCatgNumber);
  }
  openSearch() {
    this.search_btn = true;
    this.clear_Btn = false;
    this.toggleSearch = true;
    this.searchButton = false;
    this.toggleSearch = true;
    this.searchButton = false;
    this.addBtn = false;
    this.cancelTruck = true;
    this.delete = true;
    this.editTruck = false;
    this.checkBox = true;
    this.DeleteAction = true;
    if (this.toggleSearch) {
      setTimeout(() => this.newItem.nativeElement.focus(), 0);
    }
  }
  search(value: any) {
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    if (value != "") {
      this.searchButton = false;
      this.search_btn = false;
      this.clear_Btn = true;
      this.truckTypeNumber = capitalizedValue;
      this.startPage = 1;
      this.truckCategoryGet(this.truckTypeNumber, this.truckTypeNumber);
    } else {
      this.resetSearch();
    }
  }
}
